const Loader = () => {
  return (
    <button disabled="disabled" className="play_btn w-24">
      <div className="loader"></div>
    </button>
  );
};

export default Loader;
